import { gql, TypedDocumentNode } from "@apollo/client";

import {
  CreateCompanionSessionMutation,
  CreateCompanionSessionMutationVariables,
} from "./CreateCompanionSession.generated";

export const CREATE_COMPANION_SESSION: TypedDocumentNode<
  CreateCompanionSessionMutation,
  CreateCompanionSessionMutationVariables
> = gql`
  mutation createCompanionSession(
    $teamUuid: String
    $inventoryUuid: String
    $sessionType: String
  ) {
    createCompanionSession(
      teamUuid: $teamUuid
      inventoryUuid: $inventoryUuid
      sessionType: $sessionType
    ) {
      companionSessionUuid
    }
  }
`;
